function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M236.18 78C147.74 105 83.4 187.22 83.4 284.48C83.3736 309.861 87.8286 335.048 96.56 358.88L99.9 366.45",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M499.6 374C512.422 345.9 519.039 315.367 519 284.48C519 188.78 456.71 107.63 370.46 79.36",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M263.19 152.49C252.478 141.774 246.461 127.241 246.464 112.089C246.467 96.9374 252.489 82.4071 263.205 71.695C273.921 60.9829 288.454 54.9665 303.606 54.9693C318.758 54.9721 333.288 60.9939 344 71.71V72L264 153L263.19 152.49Z",
  className: "secondary-lightened-1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M303.58 169.22C296.078 169.227 288.648 167.752 281.717 164.881C274.786 162.01 268.49 157.799 263.19 152.49L344 71.71C351.984 79.7002 357.419 89.8777 359.621 100.956C361.822 112.035 360.69 123.517 356.367 133.953C352.045 144.388 344.726 153.308 335.336 159.585C325.945 165.862 314.905 169.215 303.61 169.22H303.58Z",
  className: "secondary"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M285.38 104.8L301.69 121.11L326.19 96.6",
  stroke: "white",
  strokeWidth: 10,
  strokeMiterlimit: 10
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M481 243.31V320H388V168.93C393.871 168.244 399.78 167.934 405.69 168C425.663 168 444.819 175.934 458.942 190.058C473.066 204.181 481 223.337 481 243.31Z",
  className: "primary"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M389 168.79L388.22 168.9C370.154 171.334 353.585 180.242 341.59 193.969C329.595 207.696 322.989 225.31 323 243.54V320H389V168.79Z",
  className: "primary-lightened-1"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M352.7 281H357V260H351.74C350.716 260 349.704 260.219 348.772 260.645C347.84 261.07 347.011 261.691 346.341 262.465C345.67 263.239 345.174 264.148 344.885 265.13C344.597 266.113 344.524 267.146 344.67 268.16L345.62 274.86C345.865 276.563 346.716 278.122 348.016 279.249C349.316 280.377 350.979 280.998 352.7 281Z",
  className: "primary-lightened-2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M454.53 270.08C454.53 270.57 452 291.4 452 291.4C451.11 301.09 447 311.49 441 320.18C437.449 325.427 433.029 330.03 427.93 333.79C418.53 340.55 410.55 343.41 402.85 343.41C397.783 343.358 392.788 342.194 388.22 340C384.532 338.278 381.021 336.198 377.74 333.79C372.648 330.022 368.229 325.42 364.67 320.18C358.67 311.49 354.52 301.09 353.67 291.4L352.38 281L351 259.31C351 259.31 350.46 228.93 388.26 210.4L389 210C395.1 242.39 425.93 265.48 454.53 270.08Z",
  className: "primary-lightened-2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M526 446H277.66V445.13C283.16 408.42 307.35 376.39 340.58 360.4C352.21 382.83 374.47 396.58 401.47 396.58C428.47 396.58 450.7 382.75 462.36 360.4C478.19 367.99 493.19 379.8 503.68 393.3C515.59 408.619 523.285 426.787 526 446Z",
  className: "secondary"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M463.82 361.12C457.914 372.477 449.003 381.994 438.058 388.632C427.112 395.269 414.554 398.773 401.754 398.761C388.953 398.749 376.401 395.22 365.469 388.561C354.537 381.902 345.644 372.368 339.76 361C341.34 360.21 342.96 359.5 344.59 358.8L355.48 354.18C360.015 362.49 366.701 369.427 374.838 374.266C382.975 379.105 392.263 381.668 401.73 381.685C411.197 381.702 420.494 379.174 428.648 374.365C436.803 369.556 443.514 362.643 448.08 354.35L458.82 358.88C460.52 359.57 462.18 360.32 463.82 361.12Z",
  className: "secondary-lightened-1"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191 159H193V288L191 287.14C177.655 282.553 166.076 273.913 157.878 262.427C149.681 250.94 145.275 237.181 145.275 223.07C145.275 208.959 149.681 195.2 157.878 183.713C166.076 172.227 177.655 163.587 191 159Z",
  className: "primary-lightened-1"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M214 290.8C206.179 290.921 198.397 289.682 191 287.14V159C200.263 155.829 210.103 154.703 219.843 155.701C229.582 156.699 238.99 159.797 247.417 164.781C255.844 169.764 263.091 176.516 268.657 184.57C274.224 192.625 277.978 201.79 279.661 211.435C281.344 221.08 280.916 230.975 278.406 240.438C275.897 249.902 271.366 258.709 265.125 266.253C258.884 273.796 251.081 279.897 242.255 284.135C233.429 288.373 223.789 290.647 214 290.8V290.8Z",
  className: "primary"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M264 250H272.38C274.136 250 275.82 250.697 277.061 251.939C278.303 253.18 279 254.864 279 256.62V266.38C279 268.136 278.303 269.82 277.061 271.061C275.82 272.303 274.136 273 272.38 273H264V250Z",
  className: "primary-lightened-2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160 273H151.62C149.864 273 148.18 272.303 146.939 271.061C145.697 269.82 145 268.136 145 266.38V256.62C145 254.864 145.697 253.18 146.939 251.939C148.18 250.697 149.864 250 151.62 250H160V273Z",
  className: "primary-lightened-2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M210 388.32L267.65 446H350C349.883 438.586 348.948 431.208 347.21 424C337.11 382.16 300.91 351.74 258.06 347.71L251.33 347.08L210 388.32Z",
  className: "primary"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.49 446H273.54L212.92 385.38L212.75 385.52L174.3 347.25L168.3 347.75C129.54 351 95.58 375.9 81.93 412.34C77.8741 423.109 75.6959 434.494 75.49 446Z",
  className: "primary-lightened-1"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M222.35 226.57L211.35 237.57L190.9 217.09L155.47 251.49L156.87 284.13C157.174 292.556 159.405 300.801 163.393 308.231C167.38 315.661 173.016 322.078 179.87 326.99C189.363 333.807 200.753 337.478 212.44 337.489C224.127 337.5 235.524 333.849 245.03 327.05L245.12 326.99C251.99 322.076 257.642 315.652 261.64 308.211C265.637 300.77 267.875 292.511 268.18 284.07L269.57 251.49L267.81 250.56C249.3 247.52 222.35 226.57 222.35 226.57Z",
  className: "primary-lightened-2"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174 409H140V420H174V409Z",
  className: "primary"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

export default __webpack_public_path__ + "static/media/suggested_employee_feedback_provider.fb6393f2.svg";
export { SvgComponent as ReactComponent };